import Vue from "vue";
import { Component } from "vue-property-decorator";
import { IExpedition, ExpeditionType, IPermission } from "@/models";
import DatePicker from "vue2-datepicker";
import { ToastHelper } from "@/helpers/ToastHelper";
import moment from "moment";
import vSelect from "vue-select";
import carousel from "vue-owl-carousel";

@Component({
    name: "ExpeditionCardReference",
    components: {
        "datepicker": DatePicker,
        "v-select": vSelect,
        carousel,
    },
})

export default class ExpeditionCardReference extends Vue {
    public time: string = moment().format("YYYY-MM-DD HH:mm");

    public editExpedition: boolean = false;

    public internalExpedition: IExpedition = null;

    public readonly deleteExpeditionModal: string = "deleteExpeditionModal";

    public deleteComment: string;

    public showPalletsData: boolean = false;

    public editPallets: boolean = false;

    public textButton: string = "Details palettes";

    public textButtonPallet: string = "Modifier";

    constructor() {
        super();

        this.deleteComment = "";
    }

    public created(): void {
        this.$parent.$data.title = "Fiche descriptive";

        if (this.expedition.effectiveArrival !== null) {
            this.time = moment(this.expedition.effectiveArrival).format("YYYY-MM-DD HH:mm");
        }

        this.internalExpedition = {
            ...this.expedition,
            expeditionIncompletePallets: this.expedition.expeditionIncompletePallets.map(eic => {
                return { ...eic };
            }),
        };
        if (this.expedition.transporter) {
            this.internalExpedition.transporter = { ...this.expedition.transporter };
        }
    }

    public get sasToken(): string {
        return this.$store.state.app.sasToken;
    }

    public get notBefore(): Date {
        return moment().hours(0).minutes(0).toDate();
    }

    public get expedition(): IExpedition {
        return this.$store.getters["expeditions/getSelectedExpedition"]();
    }

    public get permission(): IPermission {
        return this.$store.state.user.permission;
    }

    public next(): void {
        if (this.isValid) {
            this.$store.commit("expeditions/EDIT_SELECTED_EFFECTIVE_ARRIVAL", this.time);
            this.$parent.$data.step++;
        } else {
            ToastHelper.general.invalidModel();
        }
    }

    public get isValid(): boolean {
        return this.time !== "";
    }

    public validExpedition(): void {
        this.$store.dispatch("expeditions/editExpedition", this.internalExpedition);

        this.editExpedition = false;
    }

    public deleteExpedition(): void {
        this.$store.dispatch("expeditions/deleteExpedition", { expeditionId: this.expedition.expeditionId, deleteComment: this.deleteComment }).then(() => {
            this.$router.back();
        });
    }

    public print(): void {
        window.print();
    }

    public togglePalletsData(): void {
        this.showPalletsData = !this.showPalletsData;

        if (this.showPalletsData) {
            this.textButton = "Fiche descriptive";
        }
        else {
            this.textButton = "Details palettes";
        }
    }

    public toggleEditPallets(): void {
        this.editPallets = !this.editPallets;

        if (this.editPallets) {
            this.textButtonPallet = "Valider";
        }
        else {
            this.textButtonPallet = "Modifier";
        }
    }

    public finalValidation(): void {
        const payload: any = {
            expeditionId: this.internalExpedition.expeditionId,
            incompletePallets: this.internalExpedition.expeditionIncompletePallets,
        };

        this.$store.dispatch("expeditions/finalValidation", payload).then(() => {
            this.$router.back();
        });
    }
}
